import clsx from "clsx";
import { ReactNode } from "react";

const formClasses =
  "block w-full rounded-none border-0 border-b border-slate-200 py-3 pl-3 pr-7 my-2 text-slate-800 placeholder-slate-400";

function Label({ id, children, required, srOnly }) {
  return (
    <label
      htmlFor={id}
      className={clsx(
        "mb-3 block text-sm font-medium text-gray-700",
        srOnly && "sr-only"
      )}
    >
      {children} {required && <span className="text-red-500">*</span>}
    </label>
  );
}

export function TextField({
  id,
  label,
  labelSrOnly,
  type = "text",
  className = "",
  name = "",
  autoComplete = "",
  required,
  placeholder = "",
  error,
  ...props
}) {
  return (
    <div className={className}>
      {label && (
        <Label id={id} srOnly={labelSrOnly} required={required}>
          {label}
        </Label>
      )}
      <input
        id={id}
        type={type}
        {...props}
        required={required}
        className={clsx(formClasses, error && "border-red-500")}
        placeholder={placeholder}
        autoComplete={autoComplete}
        name={name}
      />
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}

export function SelectField({
  id,
  label,
  required = true,
  className = "",
  options = [],
  error,
  ...props
}) {
  return (
    <div className={className}>
      {label && (
        <Label id={id} required={required}>
          {label}
        </Label>
      )}
      <select
        id={id}
        {...props}
        className={clsx(formClasses, "pr-8", error && "border !border-red-500")}
      >
        <option value="">Select</option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}

export const Field = ({ label, required, children, error }) => {
  return (
    <div>
      <label>
        <span className="text-sm text-slate-900">
          {label} {required && <span className="text-red-500">*</span>}
        </span>
        {children}
      </label>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export const InputField = ({
  label,
  name,
  type = "text",
  placeholder,
  required = true,
  onChange = () => {},
  error,
  ...props
}) => {
  return (
    <Field label={label} required={required} error={error}>
      <input
        name={name}
        type={type}
        {...props}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className={clsx(
          "w-full rounded-none border-0 border-b border-slate-200 py-3 pl-3 pr-7 my-2 text-slate-800 placeholder-slate-400",
          error && "border !border-red-500"
        )}
      />
    </Field>
  );
};

export const TextareaField = ({
  label,
  name,
  placeholder,
  required = true,
  onChange = () => {},
  error,
  ...props
}) => {
  return (
    <Field label={label} required={required} error={error}>
      <textarea
        name={name}
        {...props}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className={clsx(
          "h-40 w-full rounded-none border-b border-slate-200 py-3 pl-3 pr-7 text-slate-800 placeholder-slate-400",
          error && "border !border-red-500"
        )}
      />
    </Field>
  );
};
